"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQQHOME = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var title_quotetable_1 = require("./shared/title/title_quotetable");
require("./qqzs.less");
var title_bar_1 = require("./shared/title_bar");
var zixun_1 = require("./shared/zixun");
var globaltime_1 = require("./shared/globaltime");
/**
 * 全球指数首页
 * @returns
 */
function PageQQHOME() {
    return (react_1.default.createElement("div", { className: "pageqqzs" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(globaltime_1.GlobalTime, { mt: 10 }),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 10 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "//kuaixun.eastmoney.com/" }, "\u6700\u65B0\u6D88\u606F")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(zixun_1.LastNewsScroll, null))),
        react_1.default.createElement(layout_1.Layout3, { mt: 5 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(QQZSTable, { txt: "\u4E9A\u6D32\u80A1\u5E02", fs: "i:1.000001,i:0.399001,i:0.399005,i:0.399006,i:1.000300,i:100.HSI,i:100.HSCEI,i:124.HSCCI,i:100.TWII,i:100.N225,i:100.KOSPI200,i:100.KS11,i:100.STI,i:100.SENSEX,i:100.KLSE,i:100.SET,i:100.PSI,i:100.KSE100,i:100.VNINDEX,i:100.JKSE,i:100.CSEALL", link: "gridlist.html#global_asia" })),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(QQZSTable, { txt: "\u6B27\u6D32\u80A1\u5E02", fs: "i:100.SX5E,i:100.FTSE,i:100.MCX,i:100.AXX,i:100.FCHI,i:100.GDAXI,i:100.RTS,i:100.IBEX,i:100.PSI20,i:100.OMXC20,i:100.BFX,i:100.AEX,i:100.WIG,i:100.OMXSPI,i:100.SSMI,i:100.HEX,i:100.OSEBX,i:100.ATX,i:100.MIB,i:100.ASE,i:100.ICEXI,i:100.PX,i:100.ISEQ", link: "gridlist.html#global_euro" })),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(QQZSTable, { txt: "\u7F8E\u6D32\u80A1\u5E02", fs: "i:100.DJIA,i:100.SPX,i:100.NDX,i:100.TSX,i:100.BVSP,i:100.MXX", link: "gridlist.html#global_america" }),
                react_1.default.createElement(QQZSTable, { txt: "\u6FB3\u6D32\u80A1\u5E02", fs: "i:100.AS51,i:100.AORD,i:100.NZ50", link: "gridlist.html#global_australia", mt: 18 }),
                react_1.default.createElement(QQZSTable, { txt: "\u5176\u5B83\u6307\u6570", fs: "i:100.UDI,i:100.BDI,i:100.CRB", link: "gridlist.html#global_qtzs", mt: 18 })))));
}
exports.PageQQHOME = PageQQHOME;
/**
 * 全球指数小table
 * @param props
 * @returns
 */
function QQZSTable(props) {
    var style = {};
    if (props.mt != undefined && props.mt > 0) {
        style.marginTop = props.mt + 'px';
    }
    return (react_1.default.createElement("div", { style: style },
        react_1.default.createElement(title_quotetable_1.Title1QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: props.link }, "\u70B9\u51FB\u67E5\u770B\u66F4\u591A>>"), table_key: 'QQZS',
            fs: props.fs,
            count: 100,
            order: '',
            orderdur: 1,
            tagclass: '' },
            react_1.default.createElement("a", { href: props.link, target: "_blank" }, props.txt))));
}
